import React, { forwardRef, useImperativeHandle, useState } from 'react'

import { Botao, ModalBase, ModalRef } from 'src/componentes'
import { UsuarioParaImpersonateDTO } from 'src/dto'

import {
  ContainerDoConteudo,
  ContainerDosBotoes,
  ContainerModal,
  ListaAvisos,
  TituloPrincipal
} from './styles'

export interface ModalConfirmacaoImpersonateRef extends Omit<ModalRef, 'abrir'> {
  abrir: (usuario: UsuarioParaImpersonateDTO) => void
}

interface ModalConfirmacaoImpersonateProps {
  backdrop?: boolean
  acaoPrimaria: (usuario: UsuarioParaImpersonateDTO) => Promise<void> | void
}

const Modal: React.ForwardRefRenderFunction<
  ModalConfirmacaoImpersonateRef,
  ModalConfirmacaoImpersonateProps
> = ({ backdrop, acaoPrimaria }, ref) => {
  const [aberta, definirAberta] = useState(false)
  const [carregando, definirCarregando] = useState(false)
  const [usuario, definirUsuario] = useState<UsuarioParaImpersonateDTO>(null)

  const fechar = () => {
    definirAberta(false)
    definirUsuario(null)
  }

  const abrir = (usuario: UsuarioParaImpersonateDTO) => {
    definirUsuario(usuario)
    definirAberta(true)
  }

  useImperativeHandle<
    ModalConfirmacaoImpersonateRef,
    ModalConfirmacaoImpersonateRef
  >(ref, () => ({
    fechar,
    abrir
  }))

  const confirmar = async () => {
    try {
      definirCarregando(true)
      await acaoPrimaria(usuario)
    } finally {
      definirCarregando(false)
    }
  }

  return (
    <ModalBase
      id="modal-confirmacao-impersonate"
      aberta={aberta}
      backdrop={backdrop}
    >
      <ContainerModal>
        <TituloPrincipal>Iniciar impersonate</TituloPrincipal>
        <ContainerDoConteudo>
          <p>
            Você entrará no perfil de <strong>{usuario?.nome}</strong> e passará
            a navegar no sistema como esse usuário.
          </p>
          <ListaAvisos>
            <li>
              Apenas operações de <strong>leitura</strong> são permitidas, além
              de algumas operações de escrita necessárias.
            </li>
            <li>
              <strong>Todas as ações</strong> realizadas durante esta sessão
              serão registradas em log identificadas como impersonate.
            </li>
          </ListaAvisos>
          <p>
            Para voltar ao seu perfil, use o botão{' '}
            <strong>Sair do impersonate</strong> no topo da página.
          </p>
        </ContainerDoConteudo>
        <ContainerDosBotoes>
          <Botao
            type="button"
            id="btn_cancelar_impersonate"
            texto="Cancelar"
            tema="Link"
            disabled={carregando}
            onClick={fechar}
          />
          <Botao
            type="button"
            id="btn_confirmar_impersonate"
            texto="Confirmar"
            carregando={carregando}
            onClick={confirmar}
          />
        </ContainerDosBotoes>
      </ContainerModal>
    </ModalBase>
  )
}

export const ModalConfirmacaoImpersonate = forwardRef(Modal)
